import axios from 'axios';

export default {
    getBlog (page, pageSize , title ) {
        return axios.get('/api/news/get/list', { params: {page: page, pageSize: pageSize, title: title} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getBlogBySeoName (seoName ) {
        return axios.get('/api/news/get/blog/seoName', { params: {seoName: seoName} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

}